import React from "react";
import { useTeacherAvailabilityStore } from "../../../../Store/GroupManagement/TeacherAvailabilityStore";

export default function TableRow({ teacher, index }) {
  const { data } = useTeacherAvailabilityStore();

  return (
    <div className="buildingJournal-redhead buildingJournal-whitehead">
      <div className="buildingJournal-redhead__item stu-num">{index + 1}</div>
      <div className="buildingJournal-redhead__item room-title">
        {teacher.fullname}
      </div>
      {data?.columns?.map((item) => {
        return (
          <div
            key={item.key}
            className="buildingJournal-redhead__item buildingJournal-wrapper week-days"
          >
            {teacher?.days?.[item.key].map((element) => {
              return (
                <div
                  key={element.id}
                  className={`buildingJournal-box  ${
                    element.busy && "buildingJournal-box_orange"
                  }`}
                >
                  <h6>{element.verbose_name}</h6>
                  <span>{element.time}</span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
